import React, { useEffect, useState } from "react";
import { TableHeadersType } from "../../../../constant/tableHeadersConstants/tableHeadersType";
import { CustomerSupplierListType } from "../../../../redux/clientSettings/clientSettingTypes";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import UpdatedByAndUpdatedAt from "../../../commons/CommonUpdatedByAndUpdatedAt";
import { formateDateTime } from "../../../../utils/commonFunctions";
import TableToggleSwitch from "../../../commons/TableToggleSwitch";
import { NewDownloadIcon } from "../../../../assets/images";
import { LedgerPdfDataType } from "../../../../screens/ClientSettings/CustomerSupplierManager";
import "../../AccountsManager/AccountsModal.scss"

type AppProps = {
  data: any;
  tableHeader: TableHeadersType[];
  handleRedirectToEditForm?: (data: CustomerSupplierListType) => void;
  isEdit: boolean;
  isEditCustomerSupplierPresent: boolean;
  handleEnableDisableStatus: (data: any) => void;
  isChangeStatusCustomerSupplierPresent: boolean;
  handleLedgerStatementDownloadModal: () => void;
  handleSetLedgerStatementEmailData: (data: LedgerPdfDataType) => void;
};

const CustomerSupplierTableData = ({
  data,
  tableHeader,
  handleRedirectToEditForm,
  isEdit,
  isEditCustomerSupplierPresent,
  handleEnableDisableStatus,
  isChangeStatusCustomerSupplierPresent,
  handleLedgerStatementDownloadModal,
  handleSetLedgerStatementEmailData,
}: AppProps) => {
  const [finalList, setFinalList] = useState<any>([]);

  useEffect(() => {
    if(data?.length > 0){
      manipulateData(data);
    }
  }, [data]);

  const handleLedgerStatementDownloadData = (data: any) => {
    let finalLedgerData = {
      ledger_id: data?.ledger_id,
      legal_name: data?.legal_name,
    };
    handleSetLedgerStatementEmailData(finalLedgerData);
    handleLedgerStatementDownloadModal();
  };

  const getLedgerLevel = (ledgerLevel: number) => {
    switch (ledgerLevel) {
      case 1:
        return "ledger-list-first";
      case 2:
        return "ledger-list-second";
      case 3:
        return "ledger-list-third";
      case 4:
        return "ledger-list-fourth";
      default:
        return null;
    }
  };

  const manipulateData = (data: any) => {
    let finalData: any = [];
    data?.map((tempData: any) => {
      finalData.push({
        level: 1,
        ledger_number: tempData?.ledger_number,
        legal_name: tempData?.legal_name,
        trade_name: tempData?.trade_name,
        address1: tempData?.address1,
        email: tempData?.email,
        mobile: tempData?.mobile,
        updated_by: tempData?.updated_by,
        updated_at: tempData?.updated_at,
        country: tempData?.country,
        status: tempData?.is_disabled,
        type: tempData?.type,
        is_tree: tempData?.is_tree,
        parent_id: tempData?.parent_id,
        ledger_id: tempData?.ledger_id,
        is_disabled: tempData?.is_disabled,
        parent_ledger_details: tempData?.parent_ledger_details,
        to_show: tempData?.to_show,
      });
      if (tempData?.is_tree) {
        tempData?.tree_data?.map((tree: any) => {
          finalData.push({
            level: 2,
            ledger_number: tree?.ledger_number,
            legal_name: tree?.legal_name,
            trade_name: tree?.trade_name,
            address1: tree?.address1,
            email: tree?.email,
            mobile: tree?.mobile,
            updated_by: tree?.updated_by,
            updated_at: tree?.updated_at,
            country: tree?.country,
            status: tree?.is_disabled,
            type: tree?.type,
            is_tree: tree?.is_tree,
            parent_id: tree?.parent_id,
            ledger_id: tree?.ledger_id,
            is_disabled: tree?.is_disabled,
            parent_ledger_details: tree?.parent_ledger_details,
            to_show: tree?.to_show,
          });
          if(tree?.is_tree) {
            tree?.tree_data?.map((treeD: any) => {
              finalData.push({
                level: 3,
                ledger_number: treeD?.ledger_number,
                legal_name: treeD?.legal_name,
                trade_name: treeD?.trade_name,
                address1: treeD?.address1,
                email: treeD?.email,
                mobile: treeD?.mobile,
                updated_by: treeD?.updated_by,
                updated_at: treeD?.updated_at,
                country: treeD?.country,
                status: treeD?.is_disabled,
                type: treeD?.type,
                is_tree: treeD?.is_tree,
                parent_id: treeD?.parent_id,
                ledger_id: treeD?.ledger_id,
                is_disabled: treeD?.is_disabled,
                parent_ledger_details: treeD?.parent_ledger_details,
                to_show: treeD?.to_show,
              });
              if (treeD?.is_tree) {
                treeD?.tree_data?.map((treeD1: any) => {
                  finalData.push({
                    level: 4,
                    ledger_number: treeD1?.ledger_number,
                    legal_name: treeD1?.legal_name,
                    trade_name: treeD1?.trade_name,
                    address1: treeD1?.address1,
                    email: treeD1?.email,
                    mobile: treeD1?.mobile,
                    updated_by: treeD1?.updated_by,
                    updated_at: treeD1?.updated_at,
                    country: treeD1?.country,
                    status: treeD1?.is_disabled,
                    type: treeD1?.type,
                    is_tree: treeD1?.is_tree,
                    parent_id: treeD1?.parent_id,
                    ledger_id: treeD1?.ledger_id,
                    is_disabled: treeD1?.is_disabled,
                    parent_ledger_details: treeD1?.parent_ledger_details,
                    to_show: treeD1?.to_show,
                  });
                });
              }
            });
          }
        });
      }
    });
    setFinalList(finalData);
  };

  const renderTableData = () => {
    const finalTableData = finalList?.map((dataItem: any) => {
      return (
        <tr key={dataItem?.ledger_id}>
          {tableHeader?.length &&
            tableHeader?.map((header: TableHeadersType) => {
              if (header.value === "legal_name") {
                return <td>{dataItem?.legal_name}</td>;
              } else if (header.value === "ledger_number") {
                return (
                 <td>
                  <span
                    className={`${getLedgerLevel(dataItem?.level)} ${!dataItem?.to_show && "no-show"}`}
                  >
                    {dataItem?.ledger_number}
                  </span>
                 </td>
              );
              } else if (header.value === "trade_name") {
                return <td>{dataItem?.trade_name}</td>;
              }
              //
              else if (header.value === "email") {
                return (
                  <td className="text-left" style={{ whiteSpace: "nowrap" }}>
                    {dataItem?.email?.length > 25 ? (
                      <OverlayTrigger
                        placement="bottom"
                        delay={{ show: 250, hide: 250 }}
                        overlay={
                          <Tooltip id="button-view">{dataItem?.email}</Tooltip>
                        }
                      >
                        <span>
                          {dataItem?.email.toLowerCase()?.substr(0, 20) +
                            (dataItem?.email &&
                            dataItem?.activity_code?.length > 20
                              ? "..."
                              : "")}
                        </span>
                      </OverlayTrigger>
                    ) : dataItem?.email ? (
                      dataItem?.email
                    ) : (
                      "--/--"
                    )}
                  </td>
                );
                // return <td>{dataItem?.email?dataItem?.email:"--/--"}</td>
              }else if (header?.value === "parent_ledger"){
                return <td>{dataItem?.parent_ledger_details?.legal_name}</td>;
              } else if (header?.value === "updated_by") {
                return (
                  <td style={{ minWidth: "160px" }}>
                    <UpdatedByAndUpdatedAt
                      firstName={dataItem?.updated_by?.first_name}
                      lastName={dataItem?.updated_by?.last_name}
                      profilePic={dataItem?.updated_by?.profile_pic?.file_url}
                      updatedAt={formateDateTime(dataItem?.updated_at)}
                    />
                  </td>
                );
              } else if (header.value === "type") {
                return <td> {dataItem?.type}</td>;
              } else if (header?.value === "status") {
                return (
                  isChangeStatusCustomerSupplierPresent && (
                    <TableToggleSwitch
                      handleEnableDisableClick={handleEnableDisableStatus}
                      status={dataItem?.is_disabled === 0 ? true : false}
                      tableData={dataItem}
                    />
                  )
                );
              } else if (dataItem[header.value]) {
                return <td> {dataItem[header.value]}</td>;
              } else {
                return <td> --/-- </td>;
              }
            })}
          <td
            style={{
              width: "80px",
              textAlign: "center",
            }}
          >
            <div>
              {isEditCustomerSupplierPresent && (
                <span
                  className="d-inline-block pointer"
                  onClick={() => {
                    handleRedirectToEditForm?.(dataItem);
                  }}
                >
                  <div
                    style={{
                      color: "#d43",
                      fontSize: 20,
                    }}
                  >
                    <i className="fas fa-pen"></i>
                  </div>
                </span>
              )}
              <OverlayTrigger
                placement="top"
                delay={{ show: 250, hide: 250 }}
                overlay={
                  <Tooltip id="button-view">Download Ledger Statement</Tooltip>
                }
              >
                <img
                  src={NewDownloadIcon}
                  alt=""
                  style={{ paddingLeft: "10px", cursor: "pointer" }}
                  onClick={() => handleLedgerStatementDownloadData(dataItem)}
                />
              </OverlayTrigger>
            </div>
          </td>
        </tr>
      );
    });

    return finalTableData;
  };

  return <>{renderTableData()}</>;
};

export default CustomerSupplierTableData;
